/**
 * Скрипты для детальных страниц проектов/новостей лендинга "РФС футбольная страна"
 */
var popupDetail = function ($item) {
    var PROGECT_DETAIL = 'project';
    var selectors = {
        hiddenText: '.js-detail-popup-handle-text',
        detailPopup: '.js-detail-popup',
        detailPopupTitle: '.js-detail-popup-title',
        detailPopupNomination: '.js-detail-popup-nomination',
        detailPopupDates: '.js-detail-popup-dates',
        detailPopupRegion: '.js-detail-popup-region',
        detailPopupDescription: '.js-detail-popup-text',
        detailPopupImg: '.js-detail-popup-image',
        detailPopupTopBlock: '.js-detail-popup-top',
        detailContent: '.js-detail-content',
    };

    var $holder;
    if ($item.hasClass('.js-detail-popup-handle')) {
        $holder = $item;
    } else {
        $holder = $item.closest('.js-detail-popup-handle');
    }
    var detailType = $holder.data('detail');
    var $detailPopup = $(selectors.detailPopup);
    var name = $holder.data('name');
    var nomination = $holder.data('nomination');
    var dates = $holder.data('season_id');
    var region = $holder.data('region');
    var image = $holder.data('image');
    var htmlText = $holder.find(selectors.hiddenText).get(0).innerHTML;

    if (detailType === PROGECT_DETAIL) {
        $detailPopup.find(selectors.detailPopupNomination).text(nomination);
        $detailPopup.find(selectors.detailPopupRegion).text(region);
    }

    $detailPopup.find(selectors.detailContent).addClass(detailType);

    $detailPopup.find(selectors.detailPopupTitle).text(name);
    $detailPopup.find(selectors.detailPopupDates).text(dates);
    $detailPopup.find(selectors.detailPopupImg).attr('src', image);
    $detailPopup.find(selectors.detailPopupDescription).html(htmlText);

    $(window).on('close-popup', function () {
        $detailPopup.find(selectors.detailContent).removeClass(detailType);
        $detailPopup.find(selectors.detailPopupNomination).text('');
        $detailPopup.find(selectors.detailPopupRegion).text('');
        $detailPopup.find(selectors.detailPopupImg).attr('src', '');
    });

    //инициализируем кастомный скролл бар, для этого предварительно насчитываем высоту
    setTimeout(function (){
        var topBlockHeight = $detailPopup.find(selectors.detailPopupTopBlock).outerHeight() + parseInt($detailPopup.find(selectors.detailPopupTopBlock).css('padding-top')) + parseInt($detailPopup.find(selectors.detailPopupTopBlock).css('padding-bottom'));
        var scrollHeight = $(window).height() - topBlockHeight;
        console.log(topBlockHeight)
        $detailPopup.find('.js-custom-scrollbar').css({'height': scrollHeight});
        $detailPopup.each(function () {
            var $scrollItem = $(this).find('.js-custom-scrollbar');
            new SimpleBar($scrollItem.get(0), { autoHide: false });
        })
    }, 0);

};
